/**
 * Off-palette value specific to primary button instances
 * @see TODO: https://jira.mongodb.org/browse/LG-5388
 */
export const PRIMARY_BUTTON_INTERACTIVE_GREEN = '#00593F';
